import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import dayjs from 'dayjs';

const firebaseRef = firebase.database();

export default function getFormFieldDate(leadId, value) {
	console.log('ADD TO DATE IS TRUE');
	var data;
	var signatureTimestamp;
	firebaseRef
		.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/documentInformation/signatureRequests'
		)
		.once('value', (snapshot) => {
			console.log('getFormFieldInfo snapshot val', snapshot.val());
			var snap = snapshot.val();

			var snapKeys = snap && Object.keys(snap);

			var apsSig = snapKeys && snap[snapKeys[0]];

			var sigUpdates = apsSig?.['signatureUpdates'];

			var sigUpdateKeys = sigUpdates && Object.keys(sigUpdates);

			sigUpdateKeys?.forEach((sigKey) => {
				var mySignature =
					sigUpdates?.[sigKey]?.['signature_request']?.[
						'signatures'
					]?.[0];

				if (mySignature?.['status_code'] === 'signed') {
					signatureTimestamp = mySignature['signed_at'];
				}
			});
			console.log(signatureTimestamp);

			var dataToReturn = dayjs(
				dayjs(signatureTimestamp * 1000).unix() * 1000 +
					86400000 * value
			).format('YYYY-MM-DD');
			console.log('RETURNED DATE ' + dataToReturn.toString());

			data = dataToReturn.toString();
		});
	return data;
}
